import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Products from './components/Products';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import ClientResults from './pages/ClientResults';
import Contact from './pages/Contact';
import About from './pages/About';
import ScrollToTop from './components/ScrollToTop';
import ServicesPage from './pages/Products';

function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <Testimonials />
      <Products />
      <CallToAction />
    </>
  );
}

function App() {
  useEffect(() => {
    // Update page title
    document.title = 'Elite Shape Personal Training';
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-black text-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/client-results" element={<ClientResults />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/recruitment" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;